export default {
  freeTimesLimitTitle: 'La prueba para la cuenta gratuita se agota hoy.',
  fileSizeLimitTitle:
    'El tamaño de los archivos de la versión gratuita no puede exceder los 20 MB.',
  total: 'Total',
  enterCode: 'Introduzca el código',
  signUpToPurchaseBtn: 'Regístrese para comprar',
  goPurchseBtn: 'Ir a la compra',
  saveTips: 'Ahorre hasta un {{num}}%',
  discount: 'Descuento',
  week: 'Semana',
  weekly: 'Semanalmente',
  montly: 'Mensualmente',
  yearly: 'Anualmente',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYearly: '3,75€',
  billMonth: '29,99€ Pagado Mensualmente',
  billYear: '179,99€ Pagado Anualmente',
  AlreadySubscribe: '¿Ya ha suscrito?',
  vipTips1: 'Sin límites de tamaño de archivo',
  vipTips2: 'Procesar cantidad de archivos sin límites',
  vipTips3: 'Cambiar fondos de imagen sin límites',
  vipTips4: 'Acceder a todas las herramientas gratuitas y funciones Premium',
  purchaseTips: 'Renovar automáticamente y cancelar en cualquier momento.',
  tips: 'Consejos:',
  promoCodeInvalidTips: 'Su código de promoción no es válido',
};
